export const questions = [
  [
    "which popular 90s street dance move involves a running motion combined with a shuffle that keeps the dancer mostly in place?",
    "what does the b in 'b-boy' stand for?", 
    "which dance style, originating in los angeles, is known for its aggressive, expressive movements and was popularised in the 2000s?",
    "the rock steady crew helped to popularise this street dance genre internationally during the 1980s. name the genre.",
    `
    you have unlocked the secret an an question!
    which of these classes does an an not teach at o school? 

    - hip hop intro, tues 7pm
    - hip hop 1, tues 8:30pm
    - choreo 1, thurs 7pm
    - choreo 2, thurs 8:30pm
    `
  ],
  [
    "which iconic street dance move did michael jackson popularize during his viral performance of 'billie jean'?",
    "name a popular south korean dance competition franchise that started in 2021, with its first season aiming to determine korea's best street dance crew.", 
    "name the dance style that shares its name with a meme often used as a joking subtitle for movie sequels.",
    "which 2000s movie franchise helped popularise street dance among mainstream audiences?", 
    "which international dance competition show, judged by jennifer lopez, ne-yo and derek hough, features crews from around the world battling for the top spot?"
  ],
  [`
  what is street dance? name as many characteristics as possible.

  each valid answer is worth 1 mark.
  0.5 mark penalty for any wrong answers.
  1 mark is worth 1/4 of your wagered points.
  `]
]

export const answers = [
  ["like jennie - jennie", "one minute man - missy elliott", "can't stop the feeling - justin timberlake", "psychic - chris brown", "don't sweat the technique - eric b. and rakim"],
  ["gnarly - katseye", "tell me - wonder girls", "it's ok i'm ok - tate mcrae", "killin' it girl - j-hope", "rude boy - rihanna (choreo by natsumi hanaoka)"],
  [
    "running man",
    "break", 
    "krumping",
    "breaking (also acceptable: b-boying, b-girling)",
    "choreo 1, thurs 7pm"
  ],
  [
    "the moonwalk",
    "street woman fighter", 
    "electric boogaloo",
    "step up", 
    "world of dance"
  ],
  [`
    any of the following, no excess denied:
    - created in public spaces (e.g. the streets)
    - comes from hip-hop or urban culture
    - created by communities
    - freedom of expression
  `]
]

const media = [
  [
    {
      url: "like-jennie.mp3",
      hard: 116.5,
      regular: 35.1
    },
    {
      url: "one-minute-man.mp3",
      hard: 40.5,
      regular: 20
    },
    {
      url: "cant-stop-the-feeling.mp3",
      hard: 172,
      regular: 0.5
    },
    {
      url: "psychic.mp3",
      hard: 89.5,
      regular: 18.5
    },
    {
      url: "dont-sweat-the-technique.mp3",
      hard: 69,
      regular: 32
    }
  ],
  [
    {
      url: "gnarly.mp4",
      hard: 85,
      regular: 29.5
    },
    {
      url: "tell-me.mp4",
      hard: 84,
      regular: 8.5
    },
    {
      url: "its-ok-im-ok.mp4",
      hard: 53.5,
      regular: 95
    },
    {
      url: "killin-it-girl.mp4",
      hard: 136,
      regular: 57.5 
    },
    {
      url: "rude-boy.mp4",
      hard: 18.5,
      regular: 0.5
    }
  ]
]

export function retrieveMedia(cat, qn) {
  return media[cat][qn]
}
